import { isEqual } from "date-fns";
import dxAccordion from "devextreme/ui/accordion";
import React from "react";
import $ from "jquery";
import { useDispatch, useSelector } from "react-redux";
import MdaeButton from "../../../common_components/common_widgets/button";
import { ADD_TASK_MODE, openTaskTriggerPopupInEditMode } from "./add-task";
import {
  formatProcessTemplateTaskTriggerToDisplay,
  MDAUDIT_TRANSFER,
  REMOVE_TASK_TRIGGER,
  RESET_ADD_TASK_TRIGGER_POPUP_VALIDATION,
  SET_PREVIOUS_REF_TASK_DATA,
  SET_PROCESS_TEMP_ROUND_DATA,
  SET_TASK_FORM_DATA,
  SET_TASK_TEMPLATE_DATASOURCE,
  SET_TRIGGER_LIST,
  taskFormData,
  TOGGLE_ADD_TASK_MODE,
  TOGGLE_ADD_TASK_POPUP,
  TOGGLE_ROUND_TASK_TYPE,
  TOGGLE_ROUND_TASK_TYPE_VALUE,
} from "./reducer/process-template-reducer";
export interface ITaskCard {
  levelName: string;
  refTaskName?: string;
  dueInDate?: any;
  triggerType: string;
  requiredForAuditCompletionInd: boolean;
  refTaskDescription?: string;
  taskCategoryName?: string;
  taskCategoryTypeDisplayName?: string;
  refTaskId?: number;
  uniqueProcessTemplateTaskTriggerId?: any;
  eaProcessTemplateRoundId?: number;
  eaProcessTemplateRoundTaskTriggerId?: any;
  currentSelectedRoundData?: any;
  roundTaskList?: any;
  isViewOnlyMode?: boolean;
  taskTemplateUpdatedBy: string;
}
export const transferredTaskTriggerErrorMsg =
  "This task contains an incomplete task template. Please update before attempting to use this Process Template";
export const PROCESS_TEMPLATE_TASK_TRIGGERS = {
  ExternalAudit: "EA",
  ExternalAuditCase: "EAC",
  RoundStart: "RS",
  PreviousTaskStatusChange: "PTSC",
  CaseStatusChange: "CSC",
  CaseRoundOutcome: "CRO",
  AuditStatusChange: "ASC",
  LastDeterminationDate: "LDD",
  PreviousRoundCaseRoundOutcome : "PRCRO",
  AuditStartDate:"ASD"

};
export const getTaskTriggerDisplayName = (taskTriggerValue) => {
  switch (taskTriggerValue) {
    case PROCESS_TEMPLATE_TASK_TRIGGERS.ExternalAudit:
      return "Audit";
    case PROCESS_TEMPLATE_TASK_TRIGGERS.ExternalAuditCase:
      return "Case";
    case PROCESS_TEMPLATE_TASK_TRIGGERS.RoundStart:
      return "Notification Date";
    case PROCESS_TEMPLATE_TASK_TRIGGERS.PreviousTaskStatusChange:
      return "Previous Task Status Change";
    case PROCESS_TEMPLATE_TASK_TRIGGERS.CaseStatusChange:
      return "Case Status Change";
    case PROCESS_TEMPLATE_TASK_TRIGGERS.CaseRoundOutcome:
      return "Case Round Outcome";
    case PROCESS_TEMPLATE_TASK_TRIGGERS.AuditStatusChange:
      return "Audit Status Change";
    case PROCESS_TEMPLATE_TASK_TRIGGERS.LastDeterminationDate:
      return "Previous Round Determination Date - Case";
    case PROCESS_TEMPLATE_TASK_TRIGGERS.PreviousRoundCaseRoundOutcome:
      return "Previous Round Case Round Outcome";
      case PROCESS_TEMPLATE_TASK_TRIGGERS.AuditStartDate:
      return "Audit Start Date";
    default:
      break;
  }
};

const TaskCard: React.FC<ITaskCard> = (props) => {
  const dispatch = useDispatch();
  const originalTriggerList = useSelector(
    (state) => state["processTemplateReducer"].originalTriggerList,
    isEqual
  );
  const processTemplateRoundList = useSelector(
    (state) => state["processTemplateReducer"].processTemplateRoundList,
    isEqual
  );
  const accordionNo = useSelector(
    (state) => state["processTemplateReducer"].accordionNo,
    isEqual
  );
  const roundTaskTypeMode = useSelector(
    (state) => state["processTemplateReducer"].roundTaskTypeMode,
    isEqual
  );
  const toggleAddNewTaskPopupVisible = (isVisible, title = "", data = {}) => {
    dispatch({
      type: TOGGLE_ROUND_TASK_TYPE_VALUE,
      data: {
        roundTaskTypeMode: TOGGLE_ROUND_TASK_TYPE.PROCESS_TEMPLATE_ROUND_TASK,
      },
    });
    dispatch({
      type: RESET_ADD_TASK_TRIGGER_POPUP_VALIDATION,
      data: { isTasktriggerFormDataValid: true },
    });
    dispatch({
      type: TOGGLE_ADD_TASK_POPUP,
      data: {
        isAddNewTaskPopupVisible: isVisible,
        addTaskPopupTitle: title,
        selectedRoundData: props.roundTaskList,
      },
    });
    dispatch({
      type: SET_PROCESS_TEMP_ROUND_DATA,
      data: { processRoundData: props.currentSelectedRoundData },
    });
  };

  return (
    <div className={"user-task-card-container"}>
      <div
        id={"task-card" + props.uniqueProcessTemplateTaskTriggerId}
        className={`${
          props.taskTemplateUpdatedBy === MDAUDIT_TRANSFER
            ? "user-task-card-with-errors"
            : "user-task-card"
        } dx-theme-text-color dx-theme-background-color`}
        title={props.taskTemplateUpdatedBy === MDAUDIT_TRANSFER ? transferredTaskTriggerErrorMsg: ""}
      >
        <div
          onClick={() => {
            if (
              roundTaskTypeMode ==
              TOGGLE_ROUND_TASK_TYPE.PROCESS_TEMPLATE_ROUND_TASK
            ) {
              dispatch({
                type: SET_TRIGGER_LIST,
                data: {
                  originalTriggerList: originalTriggerList,
                  sequenceNo: accordionNo,
                  previousRefTaskList:
                    props.currentSelectedRoundData
                      .processTemplateRoundTaskTriggerList,
                  triggerType: props.currentSelectedRoundData.triggerType
                },
              });
              dispatch({
                type: SET_TASK_TEMPLATE_DATASOURCE,
                data: { taskFormData: { ...taskFormData, level: "All" } },
              });
              dispatch({
                type: SET_PREVIOUS_REF_TASK_DATA,
                data: {
                  previousRefTaskList:
                    props.roundTaskList.processTemplateRoundTaskTriggerList,
                  currentSelectedTaskData: props.currentSelectedRoundData,
                },
              });
              dispatch({
                type: TOGGLE_ADD_TASK_MODE,
                data: { addTaskModeValue: ADD_TASK_MODE.EDIT },
              });
              var dataToDisplay = formatProcessTemplateTaskTriggerToDisplay(
                props,
                processTemplateRoundList
              );
              dispatch({
                type: SET_TASK_FORM_DATA,
                data: {
                  taskFormData: dataToDisplay,
                },
              });
              openTaskTriggerPopupInEditMode(toggleAddNewTaskPopupVisible);
            }
          }}
        >
          <div className={"user-task-title-container"}>
            <div className={"user-task-card-name-container"}>
              <div className={"user-task-card-name"} title={props.refTaskName}>
                {props.refTaskName}
              </div>
              <div
                className={"user-task-card-status"}
                title={getTaskTriggerDisplayName(props.triggerType)}
              >
                Trigger: {getTaskTriggerDisplayName(props.triggerType)}
              </div>
              <div>Level: {props.levelName}</div>
            </div>
            <div className="remove-task-icon" title={"Delete task"}>
              {!props.isViewOnlyMode && (
                <MdaeButton
                  role="dxButton"
                  icon="dx-icon delete-action-icon"
                  id="deleteButton"
                  visible={
                    roundTaskTypeMode ==
                    TOGGLE_ROUND_TASK_TYPE.PROCESS_TEMPLATE_ROUND_TASK
                  }
                  onClick={() => {
                    dispatch({
                      type: REMOVE_TASK_TRIGGER,
                      data: {
                        refTaskId: props.refTaskId,
                        uniqueProcessTemplateTaskTriggerId:
                          props.uniqueProcessTemplateTaskTriggerId,
                        eaProcessTemplateRoundId:
                          props.eaProcessTemplateRoundId,
                        eaProcessTemplateRoundTaskTriggerId:
                          props.eaProcessTemplateRoundTaskTriggerId,
                      },
                    });
                    const accordionInstance = dxAccordion.getInstance(
                      $("[taskListAccordionSequenceNo=" + accordionNo + "]") as any
                    );
                    accordionInstance?.option("selectedIndex", 0);
                  }}
                ></MdaeButton>
              )}
            </div>
            <div className={"user-task-card-icons-container"}>
              <div>
                {props.requiredForAuditCompletionInd && (
                  <div
                    className={"fa fa-asterisk user-task-card-required-icon"}
                  ></div>
                )}
              </div>
              <div className={"user-task-card-due-date-section-container"}>
                <div
                  className="user-task-card-due-date-text"
                  title={props.dueInDate}
                >
                  Due In: {props.dueInDate}
                </div>
              </div>
            </div>
          </div>
          <div
            className={"user-task-card-description"}
            title={props.refTaskDescription}
          >
            {props.refTaskDescription}
          </div>
          <div className="user-task-title-container user-task-card-category-container bottom-container">
            <div
              className="user-task-card-category-name"
              title={props.taskCategoryName}
            >
              {props.taskCategoryName}
            </div>
            <div
              className="user-task-card-category-type"
              title={props.taskCategoryTypeDisplayName}
            >
              {props.taskCategoryTypeDisplayName}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default TaskCard;
